module.exports = __webpack_public_path__ + "static/media/payroll-gradient-calendar.f831de11.svg";